export const XLSX_EXTENSIONS_MAP = new Map([
  [
    '.xlsx',
    [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ]
  ]
]);

export const XLSX_FORMAT = '.xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';

export const CSV_EXTENSIONS_MAP = new Map([
  [
    '.csv',
    [
      'text/csv',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ],
  ],
]);

export const acceptCsvFormats =
               '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';

export const ZIP_EXTENSIONS_MAP = new Map([
  [
    '.zip',
    [
      'zip',
      'application/zip',
      'application/x-zip',
      'application/x-zip-compressed',
    ],
  ],
]);

export const ZIP_FORMAT = '.zip, application/zip, application/x-zip, application/x-zip-compressed';
